import Vue from 'vue'
import Router from 'vue-router'
// import store from '.././vuex/store'
import routers from './routers'
// import {
//   Notify
// } from 'vant'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: routers
});

/**
 * role 0 为普通用户，目前没有其他角色；
 * keepAlive 为是否缓存页面，默认为false 不缓存
 */

// 导航钩子，全局钩子
router.beforeEach((to, from, next) => {
  // 登录页面
  // console.log(from)
  if (to.meta.title) {
    window.document.title = to.meta.title;
  }
  next()
})
router.afterEach(to => { })

export default router
